<template>
  <div>
    <div class="content-header">
      <div class="left">
        <Select v-model="accoun_id" class="select" @on-change="addAccount">
          <Option v-for="(item,index) in accounts" :key="index" :value="item.id">{{item.name}}</Option>
        </Select>
      </div>
      <div class="right">
        <Button type="success" @click="save">保存</Button>
      </div>
    </div>
    <div>
      <div class="info">设备序列号: {{machine.sn}}</div>
      <div>
        <div v-for="(d,index) in dispense" :key="index" v-if="!d.is_del" class="dispense">
          <Tooltip :content="d.name" placement="top">
            <div class="name">{{d.name}}</div>
          </Tooltip>
          <InputNumber style="width:70px" :active-change="false" :max="100" :min="1" :step="1" v-model="d.extract"></InputNumber>
          <Button style="margin-left: 5px" type="error" size="small" shape="circle" @click="remove(d,index)">删除</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      machine: {},
      accoun_id: '',
      accounts: [],
      dispense: []
    }
  },
  mounted () {
    this.machineInfo({ id: this.$route.params.id }).then(res => {
      this.machine = res
      this.GetDispenseAccount({ l: 1000, agent_id: res.agent_id }).then(res => {
        this.accounts = res.data
      })
    })
    this.getMacineDispense()
  },
  methods: {
    getMacineDispense () {
      this.MachineDispense({ id: this.$route.params.id }).then(res => {
        this.dispense = res
      })
    },
    save () {
      try {
        let total = 0,
          dels = [],
          insert = [],
          update = [],
          count = 0
        this.dispense.map(item => {
          if (!item.is_del) {
            total += item.extract
            count++
          }
          if (item.id && item.is_del === 1) {
            dels.push(item.id)
          } else if (item.id) {
            update.push(item)
          } else {
            delete item.name
            insert.push(item)
          }
        })
        if (count === 0) {
        } else if (total !== 100 && this.agent.tp === 1) {
          this.$Message.error('保存失败,比例总和必须为100')
          return
        } else if (total > 100 && this.agent.tp === 0 && this.agent.id === this.machine.agent_id) {
          this.$Message.error('保存失败,比例总和不能超过100')
          return
        } else if (total !== 100 && this.agent.tp === 0 && this.agent.id !== this.machine.agent_id) {
          this.$Message.error('保存失败,比例总和必须为100')
          return
        }
        this.SaveDispense({ machine_id: this.machine.id, insert: insert, update: update, dels: dels }).then(res => {
          if (res) {
            this.$Message.success('保存成功')
          } else {
            this.$Message.warning('操作已成功,无需再次操作')
          }
          this.getMacineDispense()
        })
      } catch (error) {
        console.log(error)
      }
    },
    remove (data, index) {
      if (data.id) {
        data.is_del = 1
      } else {
        this.dispense.splice(index, 1)
      }
    },
    addAccount (id) {
      let data = {},
        flag = true
      this.accounts.map(item => {
        if (item.id === id) {
          data = item
        }
      })
      if ((data.open_id || data.user_id) && data.is_del === 0) {
        this.dispense.map(item => {
          if (item.dispense_account_id === id) {
            flag = false
          }
        })
        if (flag) {
          this.dispense.push({
            name: data.name,
            machine_id: this.$route.params.id,
            dispense_account_id: id,
            extract: 1
          })
        } else {
          this.$Message.error('该收款账号已存在')
        }
      } else {
        this.$Message.error('该收款账号未绑定收款方式')
      }
    },
    ...mapActions(['machineInfo', 'GetDispenseAccount', 'MachineDispense', 'SaveDispense'])
  },
  computed: mapGetters({
    agent: 'agent'
  })
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
